export function changeCouponExchangeInput(input) {
  return {
    type: 'CHANGE_COUPON_EXCHANGE_INPUT',
    input,
  };
}

export function exchangeCoupon() {
  return {
    type: 'EXCHANGE_COUPON',
  };
}

export function exchangeCouponCompletion(error, data) {
  return {
    type: 'EXCHANGE_COUPON_COMPLETION',
    error,
    data,
  };
}

export function deinitExchangeCoupon() {
  return {
    type: 'DEINIT_EXCHANGE_COUPON',
  };
}
